function initShareButton() {
  // Add a maximum retry count to prevent infinite loops
  if (!window.shareButtonRetries) {
    window.shareButtonRetries = 0;
  }
  
  // Stop retrying after 10 attempts (1 second total)
  if (window.shareButtonRetries > 10) {
    console.warn('Could not initialize share button - DetailsDisclosure not found');
    return;
  }
  
  window.shareButtonRetries++;

  if (typeof DetailsDisclosure === 'undefined') {
    setTimeout(initShareButton, 100);
    return;
  }

  if (!customElements.get('share-button')) {
    try {
      customElements.define(
        'share-button',
        class ShareButton extends DetailsDisclosure {
          constructor() {
            super();
            // Cache main details toggle early to avoid repeated queries
            this.mainDetailsToggle = this.querySelector('details');
            
            this.elements = {
              shareButton: this.querySelector('button'),
              shareSummary: this.querySelector('summary'),
              closeButton: this.querySelector('.share-button__close'),
              successMessage: this.querySelector('[id^="ShareMessage"]'),
              urlInput: this.querySelector('input')
            };

            // Early return if essential elements are missing
            if (!this.mainDetailsToggle || !this.elements.shareButton) {
              console.warn('Share button missing required elements');
              return;
            }

            this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
            this.initializeButton();
          }

          initializeButton() {
            if (navigator.share) {
              this.initializeNativeShare();
            } else {
              this.initializeFallbackShare();
            }
          }

          initializeNativeShare() {
            this.mainDetailsToggle.setAttribute('hidden', '');
            this.elements.shareButton.classList.remove('hidden');
            this.elements.shareButton.addEventListener('click', () => {
              navigator.share({ 
                url: this.urlToShare, 
                title: document.title 
              }).catch(err => {
                if (err.name !== 'AbortError') {
                  console.warn('Share failed:', err);
                }
              });
            });
          }

          initializeFallbackShare() {
            if (this.mainDetailsToggle) {
              this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
              
              const copyButton = this.mainDetailsToggle.querySelector('.share-button__copy');
              if (copyButton) {
                copyButton.addEventListener('click', this.copyToClipboard.bind(this));
              }
              
              if (this.elements.closeButton) {
                this.elements.closeButton.addEventListener('click', this.close.bind(this));
              }
            }
          }

          toggleDetails() {
            if (!this.mainDetailsToggle?.open) {
              this.elements.successMessage?.classList.add('hidden');
              this.elements.successMessage.textContent = '';
              this.elements.closeButton?.classList.add('hidden');
              this.elements.shareSummary?.focus();
            }
          }

          copyToClipboard() {
            if (!this.elements.urlInput) return;
            
            navigator.clipboard.writeText(this.elements.urlInput.value)
              .then(() => {
                this.elements.successMessage?.classList.remove('hidden');
                this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
                this.elements.closeButton?.classList.remove('hidden');
                this.elements.closeButton?.focus();
              })
              .catch(err => console.warn('Copy failed:', err));
          }

          updateUrl(url) {
            this.urlToShare = url;
            if (this.elements.urlInput) {
              this.elements.urlInput.value = url;
            }
          }
        }
      );
    } catch (error) {
      console.warn('Failed to initialize share button:', error);
    }
  }
}

// Initialize with error handling
try {
  initShareButton();
} catch (error) {
  console.warn('Share button initialization failed:', error);
}